import PipingModal from 'sma.admin/components/pipes';

const ajax = require('sma.common/ajax');

// Create a default icon template and set it as the active icon set
$.FroalaEditor.DefineIconTemplate('nucleo', '<i class="nc-icon-mini [NAME]"></i>');
$.FroalaEditor.ICON_DEFAULT_TEMPLATE = 'nucleo';

// Assign buttons to new icon identifiers
$.FroalaEditor.DefineIcon('fullscreen', { NAME: 'gestures_stretch' });
$.FroalaEditor.DefineIcon('fullscreenCompress', { NAME: 'gestures_pinch' });


$.FroalaEditor.DefineIcon('bold', { NAME: 'text_bold' });
$.FroalaEditor.DefineIcon('italic', { NAME: 'text_italic' });
$.FroalaEditor.DefineIcon('underline', { NAME: 'text_underline' });
$.FroalaEditor.DefineIcon('strikeThrough', { NAME: 'text_strikethrough' });
$.FroalaEditor.DefineIcon('paragraphFormat', { NAME: 'text_capitalize' });
$.FroalaEditor.DefineIcon('specialCharacters', { NAME: 'business_currency-euro' });
$.FroalaEditor.DefineIcon('subscript', { NAME: 'text_subscript' });
$.FroalaEditor.DefineIcon('superscript', { NAME: 'text_superscript' });

$.FroalaEditor.DefineIcon('fontFamily', { NAME: 'text_edit' });
$.FroalaEditor.DefineIcon('fontSize', { NAME: 'text_size' });
$.FroalaEditor.DefineIcon('color', { NAME: 'text_color' });

$.FroalaEditor.DefineIcon('align', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('align-left', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('align-right', { NAME: 'text_align-right' });
$.FroalaEditor.DefineIcon('align-center', { NAME: 'text_align-center' });
$.FroalaEditor.DefineIcon('align-justify', { NAME: 'text_align-justify' });


$.FroalaEditor.DefineIcon('formatOL', { NAME: 'text_list-numbers' });
$.FroalaEditor.DefineIcon('formatUL', { NAME: 'text_list-bullet' });
$.FroalaEditor.DefineIcon('outdent', { NAME: 'text_margin-right' });
$.FroalaEditor.DefineIcon('indent', { NAME: 'text_margin-left' });
$.FroalaEditor.DefineIcon('quote', { NAME: 'text_quote' });

$.FroalaEditor.DefineIcon('insertLink', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('insertImage', { NAME: 'design_image' });
$.FroalaEditor.DefineIcon('insertTable', { NAME: 'media-1_grid' });

$.FroalaEditor.DefineIcon('insertHR', { NAME: 'ui-1_simple-delete' });
$.FroalaEditor.DefineIcon('clearFormatting', { NAME: 'ui-2_ban' });

$.FroalaEditor.DefineIcon('html', { NAME: 'design_code' });
$.FroalaEditor.DefineIcon('piping', { NAME: 'arrows-2_round-up-right' });

$.FroalaEditor.DefineIcon('undo', { NAME: 'arrows-1_refresh-68 flip-y' });
$.FroalaEditor.DefineIcon('redo', { NAME: 'arrows-1_refresh-68' });

$.FroalaEditor.DefineIcon('linkOpen', { NAME: 'arrows-e_share-26' });
$.FroalaEditor.DefineIcon('linkStyle', { NAME: 'design_wand' });
$.FroalaEditor.DefineIcon('linkEdit', { NAME: 'ui-1_edit-76' });
$.FroalaEditor.DefineIcon('linkRemove', { NAME: 'ui-2_link-broken-70' });

$.FroalaEditor.DefineIcon('linkBack', { NAME: 'arrows-1_simple-left' });
$.FroalaEditor.DefineIcon('linkList', { NAME: 'ui-1_zoom' });

$.FroalaEditor.DefineIcon('imageReplace', { NAME: 'arrows-1_direction-53' });
$.FroalaEditor.DefineIcon('image-align-left', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('image-align-right', { NAME: 'text_align-right' });
$.FroalaEditor.DefineIcon('image-align-center', { NAME: 'text_align-center' });
$.FroalaEditor.DefineIcon('imageRemove', { NAME: 'ui-1_trash-simple' });
$.FroalaEditor.DefineIcon('imageLink', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('imageDisplay', { NAME: 'text_capitalize' });
$.FroalaEditor.DefineIcon('imageStyle', { NAME: 'design_brush' });
$.FroalaEditor.DefineIcon('imageAlt', { NAME: 'ui-2_alert-i' });
$.FroalaEditor.DefineIcon('imageSize', { NAME: 'gestures_stretch' });
$.FroalaEditor.DefineIcon('imageUpload', { NAME: 'arrows-2_square-upload' });
$.FroalaEditor.DefineIcon('imageByURL', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('imageBack', { NAME: 'arrows-1_simple-left' });

$.FroalaEditor.DefineIcon('tableHeader', { NAME: 'travel_hotel-symbol' });
$.FroalaEditor.DefineIcon('tableRemove', { NAME: 'ui-1_trash-simple' });
$.FroalaEditor.DefineIcon('tableRows', { NAME: 'ui-2_menu-34' });
$.FroalaEditor.DefineIcon('tableColumns', { NAME: 'ui-2_menu-34 rotate-90' });
$.FroalaEditor.DefineIcon('tableStyle', { NAME: 'design_brush' });
$.FroalaEditor.DefineIcon('tableCells', { NAME: 'design_slice' });
$.FroalaEditor.DefineIcon('tableCellBackground', { NAME: 'ui-1_drop' });
$.FroalaEditor.DefineIcon('tableCellVerticalAlign', { NAME: 'arrows-1_enlarge-vertical' });
$.FroalaEditor.DefineIcon('tableCellStyle', { NAME: 'design_wand' });

// $.FE.DEFAULTS.imageInsertButtons = ['imageBack', '|', 'imageByURL'];


/**
 * We have to disable this rule since the function to convert texteditors to Froalas will not work.
 * This is a bit of a hack and just works because of how it ends up being imported.  Should likely
 * be a bit more explicit - update when upgrade to Froala v3.
 */
/* eslint-disable import/prefer-default-export */
export class TextEditor {
	constructor(options) {
		this.pipingContext = options.piping || null;
		this.el = $(options.textarea);
		this.fromModal = options.fromModal || false;

		const buttons = options.buttons || [
			'fullscreen',
			'|', 'bold', 'italic', 'underline', 'paragraphFormat',
			'fontSize', 'color', 'strikeThrough', 'subscript', 'superscript',
			'|', 'align',
			'|', 'formatOL', 'formatUL', 'outdent', 'indent',
			'-', 'insertLink', 'insertImage', 'insertTable', 'specialCharacters', 'insertHR',
			'|', 'undo', 'redo', 'clearFormatting',
			'|', 'html',
			'|', 'piping',
		];

		let config = {};

		if (this.pipingContext) {
			const { pipingContext, el, fromModal } = this;
			const that = this;
			// Assign piping logic to piping button
			$.FroalaEditor.RegisterCommand('piping', {
				title: 'Piping',
				focus: false,
				undo: false,
				refreshAfterCallback: false,
				/* eslint-disable func-names, object-shorthand */
				callback: function () {
					/* eslint-disable no-new */
					new PipingModal({
						context: pipingContext,
						$textField: this.$oel,
						froala: that,
						fromModal: fromModal,
					});
					/* eslint-enable no-new */
					this.selection.save();
				},
				/* eslint-enable func-names, object-shorthand */
			});

			config = {
				at: '{{',
				lookUpOnClick: false,
				callbacks: {
					remoteFilter: (query, queryCallback) => {
						const pipeOptions = {
							url: reverse('pipes-index'),

							data: {
								q: query.trim(),
								context: this.pipingContext,
							},
							callback: (data) => {
								let id = 1;
								const pipes = [];

								for (const groupKey in data.result) {
									const pipeGroup = data.result[groupKey];

									for (const pipeIndex in pipeGroup.data) {
										const pipe = pipeGroup.data[pipeIndex];

										const pipeObj = {
											id: id,
											name: pipe.label,
											value: `{{ ${pipe.value} }}`
										};
										id ++;
										pipes.push(pipeObj);
									}
								}
								queryCallback(pipes);
							},
						};
						ajax.get(pipeOptions);
					},
					// Overwrite matcher so we can accept spaces
					matcher: (flag, subtext, shouldStartWithSpace) => {
						let _a;
						let _y;
						let match;
						let regexp;
						let space;
						flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

						if (shouldStartWithSpace) {
							flag = '(?:^|\\s)' + flag;
						}

						_a = decodeURI('%C3%80');
						_y = decodeURI('%C3%BF');
						space = '\ '; // these spaces
						regexp = new RegExp(flag + "([A-Za-z" + _a + "-" + _y + "0-9_" + space + "\'\.\+\-]*)$|" + flag + "([^\\x00-\\xff]*)$", 'gi');
						match = regexp.exec(subtext);
						if (match) {
							return match[2] || match[1];
						} else {
							return null;
						}
					},
					// Overwrote sorter so we can trim whitespace
					sorter: (query, items, searchKey) => {
						let _results;
						let i;
						let item;
						let len;
						if (!query) {
							return items;
						}
						_results = [];
						for (i = 0, len = items.length; i < len; i++) {
							item = items[i];
							item.atwho_order = new String(
								item[searchKey]).toLowerCase().indexOf(query.toLowerCase().trim()); // trims here
							if (item.atwho_order > -1) {
								_results.push(item);
							}
						}
						return _results.sort((a, b) => {
							return a.atwho_order - b.atwho_order;
						});
					},
				},
				displayTpl: '<li>${name} <small>${value}</small></li>',
				insertTpl: '<span class="sma-pipe" data-toggle="tooltip" data-placement="top" title="${name}">${value}</span>',
				limit: 100,
			};
		} else {
			const index = buttons.indexOf('piping');
			if (index > -1) {
				buttons.splice(index, 1);
			}
		}

		this.el.on('froalaEditor.initialized', (e, editor) => {
			if (this.pipingContext) {
				editor.$el.atwho(config).on('inserted.atwho', function() {
					editor.$el.find('.atwho-inserted').removeAttr('contenteditable');
				});
			}

			editor.events.on('keydown', (keydownEvent) => {
				let returnValue;
				if (keydownEvent.which === $.FroalaEditor.KEYCODE.ENTER && editor.$el.atwho('isSelecting')) {
					returnValue = false;
				}
				return returnValue;
			}, true);
		}).froalaEditor({
			heightMin: options.heightMin || 200,
			imageEditButtons: [
				'imageAlign', 'imageCaption', 'imageRemove', '|',
				'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '|',
				'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize',
			],
			imageInsertButtons: ['imageBack', '|', 'imageByURL'],
			imagePaste: false,
			imageUploadRemoteUrls: false,
			language: window.__LANGUAGE,
			placeholderText: options.placeholderText || null,
			toolbarButtons: buttons,
		});

		this.el.on('froalaEditor.contentChanged', () => {
			this.el.val(this.getContent()).change();
		});
	}

	setContent(content) {
		this.el.froalaEditor('html.set', content);
		this.el.froalaEditor('events.trigger', 'charCounter.update');
	}

	getContent() {
		return this.el.froalaEditor('html.get', true);
	}

	insertText(tags, el) {
		let insertedContent = tags.map((tag) => {
			return `
				<span class="atwho-inserted" data-atwho-at-query="{{">
					<span
						class="sma-pipe"
						data-toggle="tooltip"
						data-placement="top"
						title="${tag.group} ${tag.label}"
					>
						{{ ${tag.value} }}
					</span>
				</span>
			`;
		});
		insertedContent = insertedContent.join(' ');
		el.froalaEditor('selection.restore');
		el.froalaEditor('html.insert', insertedContent, true);
	}
}
/* eslint-enable import/prefer-default-export */

// convert all sma-text-editor textareas
$(function() {
	$('textarea.sma-text-editor').each((i, textarea) => {
		const contextString = $(textarea).attr('data-context');
		const context = contextString ? contextString.split(' ') : null;

		new TextEditor({
			textarea,
			piping: context
		});
	});
});

module.exports = TextEditor;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.common/texteditor.js